module.exports = __webpack_public_path__ + "static/analog-photo-10-69cd6125baf4a6a60c6b94c2f9f2c667.jpg";